import * as React from "react";
import { useLingui } from "@lingui/react/macro";
import { authMessageDescriptor } from "shared/dto/auth/messages";

/**
 * 인증 폼(react-hook-form + valibot)의 에러 메시지를 화면 문구로 바꿔준다.
 *
 * shared/dto/auth 의 스키마는 서버 워커와 공유하느라 메시지를 번역 대신 키로 들고
 * 있다(예: "auth.email.invalid"). 키면 현재 언어로 번역하고, 키가 아니면(서버가
 * 그대로 돌려준 문구 등) 원문을 그대로 돌려준다.
 */
export function useAuthErrorText(): (message: string | undefined) => string | undefined {
  const { i18n } = useLingui();
  return React.useCallback(
    (message: string | undefined) => {
      if (!message) return undefined;
      const descriptor = authMessageDescriptor(message);
      return descriptor ? i18n._(descriptor) : message;
    },
    [i18n],
  );
}
